import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
//import { Box, Typography, TextField, Avatar, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

const CommentsReplyPage = () => {
  //const { commentId } = useParams();
  const [comment, setComment] = useState(null);
  const history = useHistory(); 
  const [title, setTitle] = useState('');
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
  const [replyText, setReplyText] = useState("");

  //const { id } = useParams();
  const { id, commentId } = useParams();
  const [bill, setBill] = useState(null);
  const [replyChain, setReplyChain] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [voteType, setVoteType] = useState(null); // "Pass" | "No Pass"
  const [activePostId, setActivePostId] = useState(null);

  const [replyOpen, setReplyOpen] = useState(false);
  const [activeCommentId, setActiveCommentId] = useState(null);

  const [undoDialogOpen, setUndoDialogOpen] = useState(false);
  const [pendingUndoCaseId, setPendingUndoCaseId] = useState(null);
  const [pendingUndoBill, setPendingUndoBill] = useState(null);

  const [openVotersDialog, setOpenVotersDialog] = useState(false);
  const [activeVoters, setActiveVoters] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");

  const [voteRationale, setVoteRationale] = useState(null);

  const [loggedInUser, setLoggedInUser] = useState(null);
  useEffect(() => {
        axios.get("/user/me")
            .then(res => setLoggedInUser(res.data))
            .catch(() => setLoggedInUser(null));
    }, []);

  useEffect(() => {
    axios.get(`/bill/${id}`)
      .then(res => setBill(res.data))
      .catch(err => console.error("Error loading bill", err));
  }, [id]);

  //console.log(bill);
/*
  useEffect(() => {
    const fetchComment = async () => {
      try {
        const res = await axios.get(`/commentReplies/${commentId}`);
        setComment(res.data);
        //console.log(res.data);
      } catch (err) {
        console.error("Error fetching comment:", err);
      }
    };

    fetchComment();
  }, [commentId]);
  console.log(comment);
  */
 /*useEffect(() => {
   const fetchComment = async () => {
     try {
       const res = await axios.get(`/bill/${id}/commentReplies/${commentId}`);
       setComment(res.data);
       //console.log(res.data);
     } catch (err) {
       console.error("Error fetching comment:", err);
     }
   };
   fetchComment();
 }, [commentId]);*/
  /*useEffect(() => {
    const fetchContext = async () => {
      try {
        const res = await axios.get(
          `/bill/${id}/commentReplies/${commentId}`
        );
        setReplyChain(res.data.chain);
        setComment(res.data.current);
      } catch (err) {
        console.error("Error loading comment context", err);
      }
    };

    fetchContext();
  }, [id, commentId]);*/
    const location = useLocation();
    const source = location.state?.source;

    const [isLoadingReplies, setIsLoadingReplies] = useState(false);

    // Pagination stored in refs — never captured stale in observer closures
    const cursorRef = useRef(null);
    const hasMoreRef = useRef(true);
    const isFetchingRef = useRef(false);
    const abortRef = useRef(null);

    // ── Stable navigation callbacks — safe to pass to React.memo children ──────
    const handleNavigate = useCallback((targetId) => {
        history.push(`/bill/${id}/comments/${targetId}`, { source });
    }, [history, id, source]);

    // ── Core fetch — reads cursor from ref, never from a stale closure ─────────
    const fetchReplies = useCallback(async (overrideCursor) => {
    if (isFetchingRef.current || !hasMoreRef.current) return;

    abortRef.current?.abort();
    abortRef.current = new AbortController();
    isFetchingRef.current = true;
    setIsLoadingReplies(true);

    // undefined means "use whatever cursorRef holds right now"
    const cursorToUse = overrideCursor !== undefined ? overrideCursor : cursorRef.current;

    try {
        const res = await axios.get(
        `/bill/${id}/commentReplies/${commentId}`,
        {
            params: { cursor: cursorToUse ?? undefined, limit: 10 },
            signal: abortRef.current.signal,
        }
        );

        if (!cursorToUse) {
        // Initial load
        setReplyChain(res.data.chain);
        setComment(res.data.current);
        } else {
        // Append page
        setComment(prev => prev
            ? { ...prev, replies: [...prev.replies, ...res.data.current.replies] }
            : prev
        );
        }

        // Write to refs synchronously — observer always reads current values
        cursorRef.current = res.data.nextCursor;
        hasMoreRef.current = res.data.hasMore;

    } catch (err) {
        if (axios.isCancel(err) || err.name === "CanceledError") return;
        console.error("Fetch replies failed", err);
    } finally {
        isFetchingRef.current = false;
        setIsLoadingReplies(false);
    }
    }, [id, commentId]);

    // ── Reset + initial load whenever route params change ─────────────────────
    useEffect(() => {
        cursorRef.current = null;
        hasMoreRef.current = true;
        isFetchingRef.current = false;
        setComment(null);
        setReplyChain([]);
        fetchReplies(null);
        return () => abortRef.current?.abort();
    }, [id, commentId, fetchReplies]);

    // ── IntersectionObserver on a SEPARATE sentinel div, not the last card ─────
    // This is what makes click + observer mutually exclusive at the DOM level.
    const observerRef = useRef();
    const sentinelRef = useCallback(node => {
    if (observerRef.current) observerRef.current.disconnect();
        if (!node) return;
        observerRef.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMoreRef.current && !isFetchingRef.current) {
            fetchReplies(undefined); // reads cursorRef.current internally
            }
        }, { rootMargin: "300px" });
        observerRef.current.observe(node);
    }, [fetchReplies]);

  const handleSubmit = async () => {
    try {
      await axios.post('/api/govPosts', {
        title,
        content,
        topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
      });
      setOpen(false);
      setTitle('');
      setContent('');
      alert('Post created!');
    } catch (err) {
      console.error('Failed to create post', err);
    }
  };

  const toggleVote = async (billId) => {
    try {
        const res = await axios.post(`/bill/${billId}/upvote`);
        const { upvotes, voted } = res.data;

        setBill(prevBill => ({
          ...prevBill,
          upvoteCount: upvotes,
          voted
        }));
    } catch (err) {
        console.error('Error toggling vote:', err);
    }
    };

  const toggleCommentVote = async (commentId) => {
        try {
             // hit backend endpoint that toggles a vote
             //const res = await axios.post(`/post/${postId}/upvote`);
            const res = await axios.post(`/billComments/${commentId}/upvote`);

            setComment(prev => ({
                ...prev,
                upvotes: res.data.upvotes,
                voted: res.data.voted
            }));
  
        } catch(err) {
            console.error("Vote error", err);
        }
    };
    /*
    const toggleReplyVote = async (replyId) => {
        try {
            //const res = await axios.post(`/commentReplies/${replyId}/upvote`);
            const res = await axios.post(`/bill/${id}/commentReplies/${replyId}/upvote`);

            setComment((prev) => {
              // if prev has replies (top-level comment with nested replies)
              if (prev.replies) {
                return {
                  ...prev,
                  replies: prev.replies.map((r) =>
                    r._id === replyId
                      ? { 
                          ...r, 
                          replyUpvotes: res.data.replyUpvotes, 
                          replyVoted: res.data.replyVoted 
                        }
                      : r
                  ),
                };
              }

              // if prev itself IS the reply (no nested replies array)
              if (prev._id === replyId) {
                return {
                  ...prev,
                  replyUpvotes: res.data.replyUpvotes,
                  replyVoted: res.data.replyVoted,
                };
              }

              return prev;
            });
        } catch (err) {
            console.error("Reply vote error", err);
        }
        };*/
        // Recursively update a reply at any depth
    /*function updateReplyRecursive(replies, replyId, newData) {
      return (replies || []).map((r) => {
        if (r._id === replyId) {
          return { ...r, ...newData }; // update this reply
        }
        return {
          ...r,
          replies: updateReplyRecursive(r.replies, replyId, newData), // recurse
        };
      });
    }*/

    /*const toggleReplyVote = async (replyId) => {
      try {
        const res = await axios.post(`/bill/${id}/commentReplies/${replyId}/upvote`);
        const { replyUpvotes, replyVoted } = res.data;

        setComment((prev) => {
          if (!prev) return prev;

          // Case A: this comment itself is the reply
          if (prev._id === replyId) {
            return {
              ...prev,
              replyUpvotes,
              replyVoted,
            };
          }

          // Case B: it's somewhere in prev.replies (any depth)
          return {
            ...prev,
            replies: updateReplyRecursive(prev.replies, replyId, {
              replyUpvotes,
              replyVoted,
            }),
          };
        });
      } catch (err) {
        console.error("Reply vote error", err);
      }
    };
        console.log(comment);*/
    const updateReplyChainRecursive = (nodes = [], id, updates) => {
      let changed = false;

      const next = nodes.map((n) => {
        if (n._id === id) {
          changed = true;
          return { ...n, ...updates };
        }

        const updatedReplies = updateReplyChainRecursive(n.replies, id, updates);
        if (updatedReplies !== n.replies) {
          changed = true;
          return { ...n, replies: updatedReplies };
        }

        return n;
      });

      return changed ? next : nodes;
    };

    const updateReplyRecursive = (replies = [], replyId, updates) => {
      return replies.map((r) => {
        if (r._id === replyId) {
          return { ...r, ...updates };
        }

        return {
          ...r,
          replies: updateReplyRecursive(r.replies, replyId, updates),
        };
      });
    };

    const toggleReplyVote = async (replyId) => {
      try {
        const res = await axios.post(
          `/bill/${id}/commentReplies/${replyId}/upvote`
        );

        const { replyUpvotes, replyVoted } = res.data;

        setComment((prev) => {
          if (!prev) return prev;

          // Case A: current focused comment is the reply
          if (prev._id === replyId) {
            return {
              ...prev,
              replyUpvotes,
              replyVoted,
            };
          }

          // Case B: reply exists somewhere in the chain
          return {
            ...prev,
            replies: updateReplyRecursive(prev.replies, replyId, {
              replyUpvotes,
              replyVoted,
            }),
          };
        });

        setReplyChain((prev) =>
          updateReplyChainRecursive(prev, replyId, {
            replyUpvotes,
            replyVoted,
          })
        );
      } catch (err) {
        console.error("Reply vote error", err);
      }
    };
    /*const handleReplySubmit = async () => {
      if (!replyText.trim()) return;


      try {
        const res = await axios.post(`/bill/comments/${comment._id}/replies`, {
          text: replyText
        });

       setComment(prev => ({
        ...prev,
        replies: [
            ...(prev.replies || []), res.data]
        }));

       setReplyText("");
      } catch (err) {
        console.error("Reply error", err);
      }
    };
    //console.log(comment);*/
    const handleReplySubmit = async () => {
      if (!replyText.trim()) return;

      try {
        const res = await axios.post(`/billComments/${comment._id}/reply`, {
          text: replyText,
        });

        const commentRes = await axios.get(
          `/bill/${id}/commentReplies/${commentId}`
        );
        setReplyChain(commentRes.data.chain);
        setComment(commentRes.data.current);
        setReplyText("");
      } catch (err) {
        console.error("Reply error", err);
      }
    };
    const CommentCard = ({ comment }) => (
  <Box
    p={2} // padding inside box
    my={2} // vertical margin between posts
    //onClick={() => history.push(`/bill/${id}/comments/${comment._id}`)}
    onClick={() => handleNavigate(comment._id)}
    border="1px solid #ccc" // light grey border
    borderRadius="8px" // rounded corners
    sx={{
      position: "relative",
      maxWidth: 900, // limit width
      mx: "auto", // center horizontally
      my: 2, // vertical spacing between each post
      cursor: "pointer",
                 "&:hover": {
                     backgroundColor: "#f9f9f9"
                 }
    }}
  >
    <Box display="flex" alignItems="flex-start" gap={1}>
      <Avatar
        src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
        onClick={(e) => visitProfile(e, comment.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
      />
      <Box>
        <Typography variant="subtitle1" fontWeight="bold"
        onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
        >
          {comment.author?.first_name} {comment.author?.last_name}
        </Typography>
        <Typography variant="body2" color="text.secondary"
        onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
        >
          @{comment.author?.username}
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
          {comment.text}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                        {`${new Date(comment.created_at).toLocaleString()}, ${
                                            comment.replyCount ?? 0
                                        } ${comment.replyCount === 1 ? "reply" : "replies"}`}
                                    </Typography>
      </Box>
    </Box>

    <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {comment.replyVoted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleReplyVote(comment._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleReplyVote(comment._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                   </Box>
  </Box>
);

  if (!comment) return <Typography>Loading...</Typography>;

  const isTopLevel = bill?.comments?.some(c => c._id === comment._id);

  function addReplyRecursive(comment, targetId, newReply) {
    // if this comment/reply matches the target, append the new reply
    if (comment._id === targetId) {
      return {
        ...comment,
        replies: [...(comment.replies || []), newReply]
      };
    }


    // otherwise, dive into nested replies
    return {
      ...comment,
      replies: comment.replies?.map(r => addReplyRecursive(r, targetId, newReply)) || []
    };
  }
/*
const handleReplyCommentSubmit = async (targetId) => {
  if (!replyText.trim()) return;
  try {
    const res = await axios.post(`/bill/replyComments/${targetId}/replies`, {
      text: replyText
    });


    const newReply = res.data;


    // update the state recursively
    setComment(prev => addReplyRecursive(prev, targetId, newReply));


    setReplyText("");
  } catch (err) {
    console.error("Reply error", err);
  }
};
*/
const handleReplyCommentSubmit = async (targetId) => {
 if (!replyText.trim()) return;
 try {
   const res = await axios.post(`/bill/${id}/replyComments/${targetId}/replies`, {
     text: replyText
   });


   const newReply = res.data;


   // update the state recursively
   setComment(prev => addReplyRecursive(prev, targetId, newReply));


   setReplyText("");
 } catch (err) {
   console.error("Reply error", err);
 }
};

const isSameUser = (voteUser, loggedInUserId) => {
        if (!voteUser) return false;
        return typeof voteUser === "string"
            ? voteUser === loggedInUserId
            : voteUser._id === loggedInUserId;
    };

  const toggleNoPass = async (billId, commentId) => {
        try {
            const res = await axios.post(`/bill/${billId}/noPass`, {commentId});
            const { upvotes, billVoted } = res.data;

            setBill(prev => {
                if (!prev || prev._id !== billId) return prev;
                    return {
                        ...prev,

                        // update counts
                        noPassCount: upvotes,
                        //billVoted,

                        votedBill: true,
                        votedSide: "no pass",

                        // update voter list 
                        /*billVoters: [
                            ...(prev.billVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        // record no pass vote
                        noPassPowerVotes: [
                            ...(prev.noPassPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // make sure pass votes does NOT contain user
                        passPowerVotes: (prev.passPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                    }
                }
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

  const togglePass = async (billId, commentId) => {
        try {
            const res = await axios.post(`/bill/${billId}/pass`, {commentId});
            const { upvotes, billVoted } = res.data;

            setBill(prev => {
                if (!prev || prev._id !== billId) return prev;
                    return {
                        ...prev,

                        // update counts
                        passCount: upvotes,
                        //billVoted,

                        votedBill: true,
                        votedSide: "pass",

                        // update voter list
                        /*billVoters: [
                            ...(prev.billVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        // record pass vote
                        passPowerVotes: [
                            ...(prev.passPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // remove from no pass votes if present
                        noPassPowerVotes: (prev.noPassPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                    }
                }
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

  const handleOpenDialog = (billId) => {
        setActivePostId(billId);
        setOpenDialog(true);
    };

  const handleSubmitVote = async () => {
        if (!voteType || !voteRationale.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }

        try {
            const commentRes = await axios.post(
                `/bill/${activePostId}/comment`,
                { text: voteRationale }
            );

            const commentId = commentRes.data._id; 

            //setComments(prev => [commentRes.data, ...prev]);
            //const getCommentRes = await axios.get(`/bill/${id}/comments`);
            //setComments(getCommentRes.data);
            const res = await axios.get(
              `/bill/${id}/commentReplies/${commentId}`
            );
            setReplyChain(res.data.chain);
            setComment(res.data.current);

            if (voteType === "NP") {
                await toggleNoPass(activePostId, commentId);
            } else {
                await togglePass(activePostId, commentId);
            }
            setOpenDialog(false);
            setVoteRationale("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };

    /*
    const handleUndoVote = async (billId, bill) => {
	    const res = await axios.post(`/bill/${billId}/undoVote`);

        const { upvotes, billVoted, deletedCommentId } = res.data;

       if (
            bill.noPassPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            )
            ) {
                setBill(prev => {
                    if (!prev || prev._id !== billId) return prev;
                        return {
                            ...prev,

                            // keep working count logic
                            noPassCount: upvotes,
                            billVoted,

                            // remove user from arrays so button updates
                            billVoters: (prev.billVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            noPassPowerVotes: (prev.noPassPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                    }
                );
            } else if (
                bill.passPowerVotes?.some(
                    vote => isSameUser(vote.user, loggedInUser._id)
                )
            ) {
                setBill(prev => {
                    if (!prev || prev._id !== billId) return prev;
                        return {
                            ...prev,

                            // keep working count logic
                            passCount: upvotes,
                            billVoted,

                            // remove user from arrays so button updates
                            billVoters: (prev.billVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            passPowerVotes: (prev.passPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                    }
                );
            }
            //setComments(prev =>
            //    prev.filter(comment => comment._id !== deletedCommentId)
            //);
            const commentRes = await axios.get(
              `/bill/${id}/commentReplies/${commentId}`
            );
            setReplyChain(commentRes.data.chain);
            setComment(commentRes.data.current);
    };*/
    const handleUndoVote = async (billId) => {
        try {
            const res = await axios.post(`/bill/${billId}/undoVote`);
            const { upvotes, deletedCommentId } = res.data;

            setBill(prev => {
                if (!prev || prev._id !== billId) return prev;

                const updated = { ...prev };

                // Use votedSide as the single source of truth
                if (prev.votedSide === "no pass") {
                    updated.noPassCount = upvotes;
                } else if (prev.votedSide === "pass") {
                    updated.passCount = upvotes;
                }

                // Reset vote state (THIS fixes your UI instantly)
                updated.votedBill = false;
                updated.votedSide = null;

                return updated;
            });

            // Remove associated comment (if backend deleted it)
            /*if (deletedCommentId) {
                setComments(prev =>
                    prev.filter(comment => comment._id !== deletedCommentId)
                );
            }*/
           const commentRes = await axios.get(
              `/bill/${id}/commentReplies/${commentId}`
            );
            setReplyChain(commentRes.data.chain);
            setComment(commentRes.data.current);

        } catch (err) {
            console.error("Error undoing vote:", err);
        }
    };

    /*const openNoPassVoters = (e, bill) => {
        e.stopPropagation();
        setDialogTitle("No Pass Votes");
        setActiveVoters(bill.noPassPowerVotes || []);
        setOpenVotersDialog(true);
    };

    const openPassVoters = (e, bill) => {
        e.stopPropagation();
        setDialogTitle("Pass Votes");
        setActiveVoters(bill.passPowerVotes || []);
        setOpenVotersDialog(true);
    };*/
    /*
    const openNoPassVoters = async (e, bill) => {
        e.stopPropagation();
        setDialogTitle("No Pass Votes");

        try {
            const res = await axios.get(`/bill/${bill._id}/voters?side=no pass`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };

    const openPassVoters = async (e, bill) => {
        e.stopPropagation();
        setDialogTitle("Pass Votes");

        try {
            const res = await axios.get(`/bill/${bill._id}/voters?side=pass`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };*/

const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

  const billPassCount = bill?.passCount || 0;
        const billNoPassCount = bill?.noPassCount || 0;
        let votePercentage = 0;
	 
        if (billPassCount > billNoPassCount) {
            votePercentage = billPassCount/(billPassCount+billNoPassCount)
        } else if (billNoPassCount > billPassCount) {
            votePercentage = billNoPassCount/(billPassCount+billNoPassCount)
        }

        let offset = 0;
        if (billPassCount > billNoPassCount) {
            offset = votePercentage * 50; // move right
        } else if (billNoPassCount > billPassCount) {
            offset = -votePercentage * 50; // move left
        }

        let tickColor = "blue"; // default at center
        if (offset > 0) {
            tickColor = "#00c853"; // right side
        } else if (offset < 0) {
            tickColor = "red"; // left side
        }

        const navItems = [
        {
            label: "Popular Opinion",
            path: "/Government/popular",
            matchPaths: ["/Government/popular"]
        },
        {
            label: "Following",
            path: "/Government/following",
            matchPaths: ["/Government/following"]
        },
        {
            label: "Supreme Court",
            path: "/Government/SupremeCourt",
            matchPaths: [
            "/Government/SupremeCourt",
            "/scotusCase"
            ]
        },
        {
            label: "Congressional Bills",
            path: "/Government/CongressionalBills",
            matchPaths: [
            "/page2/b",
            "/bill"
            ]
        },
        {
            label: "State Legislature Bills",
            path: "/Government/StateBills",
            matchPaths: ["/Government/StateBills"]
        },
        {
            label: "Elections",
            path: "/Government/Elections/GubernatorialElections",
            matchPaths: ["/Government/Elections"]
        }
    ];

    //const location = useLocation();

    const isActive = (item) => {
        return item.matchPaths.some((match) =>
            location.pathname.startsWith(match)
        );
        };

        const getButtonStyles = (item) => {
        const active = isActive(item);

        return {
            padding: "6px 12px",
            borderColor: active ? "#1f1f1f" : "#333333",
            color: active ? "#1f1f1f" : "#333333",
            backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
            fontWeight: active ? 600 : 500,
            transition: "all 0.15s ease",
            "&:hover": {
            borderColor: "black",
            color: "black",
            backgroundColor: "rgba(0,0,0,0.12)"
            }
        };
    };
  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                      <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>
        </Box>*/}
        <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    backgroundColor: "#FFFDF8",
                    py: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                >
                    {navItems.map((item) => (
                    <Button
                        key={item.path}
                        variant="outlined"
                        sx={getButtonStyles(item)}
                        onClick={() => history.push(item.path)}
                    >
                        {item.label}
                    </Button>
                    ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
    {/* Original Bill Display */}
      <Box 
            p={2} // padding inside box
            my={2} // vertical margin between posts
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            onClick={() => history.push(`/bill/${bill._id}/comments`)}
            sx={{ 
                position: "relative", 
                maxWidth: 900, // limit width 
                mx: "auto", // center horizontally
                my: 2, // vertical spacing between each post
                cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "#f9f9f9"
                    }
            }}
        >
        <Typography 
                fontWeight="bold"
                sx={{
                    wordBreak: "break-word",
                    pr: "140px",
                    mb: 1
                }}
            >
                {bill.billNum}: {bill.title}
        </Typography>

        <Typography variant="body2" component="div">
            <Box component="span" fontWeight="bold">
                Summary:
            </Box>

            <Box
                component="div"
                sx={{ mt: 0.5 }}
                dangerouslySetInnerHTML={{ __html: bill.summary }}
            />
        </Typography>

        <Typography variant="body2">
            <Box component="span" fontWeight="bold">
                Latest Action:
            </Box>{' '}
            {bill.latestAction
                ? `${bill.latestAction.date} — ${bill.latestAction.text}`
                : 'No recent action'}
        </Typography>

        {bill.billText ? (
            <Link 
                href={bill.billText} 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ display: "block" }}
            >
                Bill Web Text
            </Link>
            ) : (
            <Typography 
                variant="caption"
                sx={{ display: "block" }}
            >
                Bill text not available
            </Typography>
        )}

          {bill.pdf ? (
            <Link
                href={bill.pdf}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                sx={{ display: "block" }}
            >
                Bill PDF
            </Link>
            ) : (
            <Typography 
                variant="caption" 
                color="text.secondary"
                sx={{ display: "block" }}
            >
                PDF not available
            </Typography>
        )}

         {/*<Box
                display="flex"
                justifyContent="center"
                sx={{ mb: 2 }}
            >
                {loggedInUser &&
                    bill.billVoters?.some(voter =>
                        isSameUser(voter, loggedInUser._id)
                ) ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": {
                            display: "none",
                            },
                            "&:hover .undo-btn": {
                            display: "inline-flex",
                            },
                        }}
                    >
                    {loggedInUser &&
                    bill.noPassPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ ml: 2.3 }}
                    >
                        Voted No Pass
                    </Button>
                    ) : loggedInUser && bill.passPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                    ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ ml: 2.3 }}
                    >
                        Voted Pass
                    </Button>
                    ) : null}
                    <Button
                        className="undo-btn"
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ display: "none", ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setPendingUndoCaseId(bill._id);
                            setPendingUndoBill(bill);
                            setUndoDialogOpen(true);
                        }}
                    >
                        Undo Vote
                    </Button>
                </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(bill._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>*/}
            <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
                {loggedInUser && bill.votedBill ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": { display: "none" },
                            "&:hover .undo-btn":  { display: "inline-flex" },
                        }}
                    >
                        <Button
                            className="voted-btn"
                            variant="outlined"
                            size="small"
                            disabled
                            sx={{ ml: 2.3 }}
                        >
                            {bill.votedSide === "no pass"
                            ? "Voted No Pass"
                            : "Voted Pass"}
                        </Button>
                        <Button
                            className="undo-btn"
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ display: "none", ml: 2.3 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setPendingUndoCaseId(bill._id);
                                setPendingUndoBill(bill);
                                setUndoDialogOpen(true);
                            }}
                        >
                            Undo Vote
                        </Button>
                    </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(bill._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>

        {/* Vote bar with tick */}
        <Box 
            display="flex" 
            alignItems="center" 
            justifyContent="center" 
            sx={{ mb: 2 }}
            >
            <Typography variant="body2">No Pass Votes</Typography>

            {/* Bar with tick in middle */}
            <Box 
                sx={{ 
                    position: "relative", 
                    height: "2px", 
                    backgroundColor: "#ccc", 
                    width: "300px",
                    mx: 2 
                }}>
                    {/* Tick in the center */}
                    <Box sx={{ 
                        position: "absolute", 
                        top: "-6px", 
                        left: "50%", 
                        transform: "translateX(-50%)", 
                        width: "2px", 
                        height: "14px", 
                        backgroundColor: "black" 
                    }} />
                
                {/* Dynamic tick + percentage */}
                <Box 
                    sx={{ 
                        position: "absolute", 
                        top: "-6px", 
                        left: `calc(50% + ${offset}%)`, 
                        transform: "translateX(-50%)", 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center"
                    }}
                    >
                    {/* Tick */}
                    <Box sx={{ 
                        width: "2px", 
                        height: "14px", 
                        backgroundColor: tickColor 
                    }} />

                    {/* Percentage */}
                    <Typography 
                        variant="caption" 
                        sx={{ mt: "2px", fontSize: "0.7rem" }}
                    >
                        {(votePercentage * 100).toFixed(0)}%
                    </Typography>
                    </Box>
                </Box>

                <Typography variant="body2">Pass Votes</Typography>
        </Box>

          <Box mt={2} display="flex" alignItems="center" gap={1}>
            <Button
                size="small"
                variant={bill.voted ? "contained" : "outlined"}
                onClick={() => toggleVote(bill._id)}
            >
                ▲ {bill.voted ? "Unvote" : "Upvote"}
            </Button>
            <Typography variant="body2">
                    {bill.upvoteCount} Visibility Upvotes |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main", }}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openNoPassVoters(e, bill)}
                    >
                        {bill.noPassCount} No Pass Votes
                    </Box>{" "}
                    |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main", }}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openPassVoters(e, bill)}
                    >
                        {bill.passCount} Pass Votes
                    </Box>
                </Typography>
          </Box>

        </Box>
    {/* --- Dialog --- */}
            <Dialog 
            open={openDialog} 
            onClose={() => setOpenDialog(false)} 
            fullWidth
            PaperProps={{
                sx: {
                backgroundColor: "#FFFDF8",
                borderRadius: 3,
                },
            }}
            >
               <DialogTitle>Cast Your Power Vote</DialogTitle>
                <DialogContent>
                    <Box display="flex" gap={2} mb={2}>
                        <Button
                            variant={voteType === "NP" ? "contained" : "outlined"}
                            onClick={() => setVoteType("NP")}
                        >
                            No Pass
                        </Button>
                        <Button
                            variant={voteType === "P" ? "contained" : "outlined"}
                            onClick={() => setVoteType("P")}
                        >
                            Pass
                        </Button>
                    </Box>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        placeholder="Explain your power vote (required)"
                        value={voteRationale}
                        onChange={(e) => setVoteRationale(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button
                        variant="outlined"
                        onClick={handleSubmitVote}
                        disabled={!voteRationale || !voteType}
                    >
                        Submit Power Vote
                    </Button>
                </DialogActions>
           </Dialog>

           <Dialog
                open={undoDialogOpen}
                onClose={() => setUndoDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                        px: 2,
                        py: 1.5,
                    },
                }}
                >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Undo your vote?
                </DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ color: "text.primary" }}>
                        This will remove your vote and the vote rationale comment associated with it.
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ pb: 2, px: 3 }}>
                    <Button
                        onClick={() => setUndoDialogOpen(false)}
                        variant="outlined"
                        sx={{
                            borderColor: "#d0cfc8",
                            color: "text.primary",
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={() => {
                            handleUndoVote(pendingUndoCaseId, pendingUndoBill);
                            setUndoDialogOpen(false);
                            setPendingUndoCaseId(null);
                            setPendingUndoBill(null);
                        }}
                        variant="contained"
                        color="error"
                        sx={{
                            boxShadow: "none",
                        }}
                    >
                        Yes, Undo Vote
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openVotersDialog}
                onClose={() => setOpenVotersDialog(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {dialogTitle}
                </DialogTitle>

                <DialogContent dividers>
                    {activeVoters.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No votes
                    </Typography>
                    ) : (
                    <List disablePadding>
                        {activeVoters.map(vote => (
                        <ListItem 
                            key={vote.user._id} 
                            button
                            onClick={(e) => visitProfile(e, vote.user._id)}
                            sx={{
                                px: 0,
                                borderRadius: 2,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                '&:hover': {
                                    backgroundColor: '#FFF2CC', // subtle highlight
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                {/* Left side: Avatar + user info */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ListItemAvatar>
                                    <Avatar src={vote.user.profileImageUrl}>
                                        {vote.user.username?.[0]}
                                    </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                        secondary={`@${vote.user.username}`}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    Voting Power: {vote.user.tier}
                                </Typography>
                            </Box>
                        </ListItem>
                        ))}
                    </List>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenVotersDialog(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
    {/* Reply chain */}
        {replyChain.map((c) => (
          <CommentCard
            key={c._id}
            comment={c}
          />
        ))}
    <Box 
              p={2} // padding inside box
              my={2} // vertical margin between posts
              border="1px solid #ccc" // light grey border
              borderRadius="8px" // rounded corners
              sx={{ 
                  position: "relative", 
                  maxWidth: 900, // limit width 
                  mx: "auto", // center horizontally
                  my: 2, // vertical spacing between each post
              }}
        >
      {/* original comment */}
      <Box display="flex" alignItems="flex-start" gap={1}>
        <Avatar
          src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
          onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{ 
                                  width: 62, 
                                  height: 62,
                                  cursor: "pointer",
                                  "&:hover": {
                                      backgroundColor: "#d9e4f0",
                                  }, 
                                  }}
        />
        <Box>
          <Typography variant="subtitle1" fontWeight="bold"
          onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
          >
            {comment.author?.first_name} {comment.author?.last_name}
          </Typography>
          <Typography variant="body2" color="text.secondary"
          onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
          >
            @{comment.author?.username}
          </Typography>
          <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
            {comment.text}
          </Typography>
          {/*<Typography variant="caption" color="text.secondary">
            {new Date(comment.created_at).toLocaleString()}
          </Typography>*/}
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
          {`${new Date(comment.created_at).toLocaleString()}, ${
            comment.replyCount
          } ${comment.replyCount === 1 ? "reply" : "replies"}`}
        </Typography>
        </Box>
      </Box>

      {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                            <Button
                                size="small"
                                //variant={comment.voted ? "contained" : "outlined"}
                                variant={
                                  isTopLevel
                                    ? (comment.voted ? "contained" : "outlined")
                                    : (comment.replyVoted ? "contained" : "outlined")
                                }
                                onClick={(e) => {
                                  e.stopPropagation(); 
                                  //toggleCommentVote(comment._id)}
                                  if (isTopLevel) {
                                    toggleCommentVote(comment._id);
                                  } else {
                                    toggleReplyVote(comment._id);
                                  }}
                                }
                            >
                                ▲ {isTopLevel
                                  ? (comment.voted ? "Unvote" : "Upvote")
                                  : (comment.replyVoted ? "Unvote" : "Upvote")}
                            </Button>
                            <Typography variant="body2">
                              {isTopLevel ? comment.upvotes : comment.replyUpvotes} upvotes
                            </Typography>
                        </Box>*/}
          <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {comment.replyVoted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReplyVote(comment._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleReplyVote(comment._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                    </Box>
    </Box>
    {/* Comment Form */}
      <Box 
            p={2} // padding inside box
            my={2} // vertical margin between posts
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            sx={{ 
                position: "relative", 
                maxWidth: 900, // limit width 
                mx: "auto", // center horizontally
                my: 2, // vertical spacing between each post
            }}
        >
        <TextField
          fullWidth
          multiline
          rows={2}
          placeholder="Engage in intellectual discourse..."
          value={replyText}
          onChange={(e) => setReplyText(e.target.value)}
        />
        {/*<Button variant="outlined" sx={{ mt: 1 }} onClick={handleReplySubmit}>*/}
        <Button 
          variant="outlined" 
          sx={{ mt: 1 }} 
          onClick={(e) => {
            e.stopPropagation();
            handleReplySubmit();
          }}
        >
          Reply
        </Button>
      </Box>
      {/* replies */}
        {comment.replies.length != 0 || hasMoreRef.current ? (
          comment.replies.map((reply, i) => {
            const isLast = i === comment.replies.length - 1;
            return (
            <Box 
              p={2} // padding inside box
              key={reply._id}
              ref={isLast ? sentinelRef : null}
              //onClick={() => history.push(`/commentReplies/${reply._id}`)} 
              //onClick={() => history.push(`/bill/${id}/comments/${reply._id}`)} 
              onClick={() => handleNavigate(reply._id)}
              my={2} // vertical margin between posts
              border="1px solid #ccc" // light grey border
              borderRadius="8px" // rounded corners
              sx={{ 
                  position: "relative", 
                  maxWidth: 900, // limit width 
                  mx: "auto", // center horizontally
                  my: 2, // vertical spacing between each post
                  cursor: "pointer",
                  "&:hover": {
                      backgroundColor: "#f9f9f9"
                  }
              }}
        >
            <Box display="flex" alignItems="flex-start" gap={1}>
                            <Avatar
                                src={reply.author?.profileImageUrl || '/default-avatar.jpg'}
                                alt={`${reply.author?.first_name || ''} ${reply.author?.last_name || ''}`}
                                onClick={(e) => visitProfile(e, reply.author?._id)}
                                sx={{ 
                                  width: 62, 
                                  height: 62,
                                  cursor: "pointer",
                                  "&:hover": {
                                      backgroundColor: "#d9e4f0",
                                  }, 
                                  }}
                            />
                            <Box>
                                <Typography variant="subtitle1" fontWeight="bold"
                                onClick={(e) => visitProfile(e, reply.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                                >
                                {reply.author?.first_name && reply.author?.last_name
                                    ? `${reply.author.first_name} ${reply.author.last_name}`
                                    : 'Unknown Name'}
                                </Typography>
                                <Typography variant="body2" color="text.secondary"
                                onClick={(e) => visitProfile(e, reply.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                                >
                                @{reply.author?.username || 'unknown'}
                                </Typography>

                                {/* Post content */}
                                <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                    {reply.text}
                                </Typography>

                                {/* Date */}
                                {/*<Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                    {new Date(reply.created_at).toLocaleString()}
                                </Typography>*/}
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{ display: "block", mt: 0.5 }}
                                >
                                  {`${new Date(reply.created_at).toLocaleString()}, ${
                                    reply.replyCount ?? 0
                                  } ${reply.replyCount === 1 ? "reply" : "replies"}`}
                                </Typography>

                            </Box>
                        </Box>
                
              {/*<Typography variant="subtitle2" fontWeight="bold">
                {reply.author?.first_name} {reply.author?.last_name}
              </Typography>
              <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
                {reply.text}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {new Date(reply.created_at).toLocaleString()}
              </Typography>*/}
              {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                            <Button
                                size="small"
                                variant={reply.replyVoted ? "contained" : "outlined"}
                                onClick={(e) => {
                                  e.stopPropagation(); 
                                  toggleReplyVote(reply._id)}
                                }
                            >
                                ▲ {reply.replyVoted ? "Unvote" : "Upvote"}
                            </Button>
                            <Typography variant="body2">{reply.replyUpvotes} upvotes</Typography>
                        </Box>*/}
                <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {reply.replyVoted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleReplyVote(reply._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleReplyVote(reply._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{reply.replyUpvotes} Power Votes</Typography>
                   </Box>
            </Box>
            )})
        ) : (
          <Typography></Typography>
        )}
    </div>
  );
};

export default CommentsReplyPage;